import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
    return createStyles({
        placementTop: {
            top: '0',
        },
        placementBottom: {
            top: 'auto',
            bottom: 0,
        },
        colorSecondary: {
            backgroundColor: theme.palette.secondary.dark,
        },
    });
};

export default makeStyles(styles, { name: 'MuiAppBarExtend' });
